export default __webpack_public_path__ + "static/media/job_offer13_xl.4b74ea15.jpg";